<template>
    <div>
        <div class="flex justify-center" style="flex-wrap: wrap;">
            <button class="btnMenu menu0 activeBtn" @click="filtro = 0;estadoMenu();getRecurso();">Pendientes</button>
            <button class="btnMenu menu1"           @click="filtro = 1;estadoMenu();getRecurso();">Finalizadas</button>
            <button class="btnMenu menu2"           @click="filtro = 2;estadoMenu();getRecurso();">Todas</button>
        </div>
        <div>
            <ListadoRecursosEstudianteVue :filtro="filtro" :codigoCurso="codigoCurso" :arregloRecursos="arregloRecursos"/>
        </div>
    </div>
</template>
<script>
import ListadoRecursosEstudianteVue from './recursos/ListadoRecursoEstudiante.vue';
export default{
    data(){
        return{
            filtro:0,
            usuario:[],
            arregloRecursos:[],
        }
    },
    components:{
        ListadoRecursosEstudianteVue,
    },
    props:{
        codigoCurso:{
            type:String,
            default:'',
        },
    },
    created() {
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted() {
        let me = this;
        me.getRecurso()
    },
    methods: {
        estadoMenu(){
            let me = this;
            localStorage.setItem('menuSelect',me.filtro)
            var divs = document.querySelectorAll(".btnMenu");
            for (var i = 0; i < divs.length; i++) {
                divs[i].classList.remove("activeBtn");
            }
            const container = document.querySelector(".menu"+me.filtro);
            container.classList.add("activeBtn");
        },
        getRecurso() {
            let me = this;
            // console.log('me.codigocurso en recurso',me.codigoCurso)
            me.$vs.loading()
            var url = ""
            url = this.$server_url + 'recursos?recursosEstudiante=yes&codigoCurso='+me.codigoCurso+'&idusuario='+me.usuario.idusuario
            this.$http.get(url)
                .then(res => {
                    // console.log(res.data)
                    me.$vs.loading.close()
                    let datos = res.data
                    if(me.filtro == 0 || me.filtro == 1){
                        me.arregloRecursos = datos.filter(p => p.estadoTarea == me.filtro)
                        return 
                    }else{
                        me.arregloRecursos = datos
                    }
                })
                .catch(error => {
                    console.log(error)
                    me.$vs.loading.close()
                })
        },
    },
}
</script>
<style lang="scss">
@import '@/assets/scss/general/general.scss';
.btnMenu{
    @include button-66;
    background-color: #fff;
    color: black;
    margin: 2px 15px;
}
.activeBtn{
    background-color: #e00a1c;
    color: white;
}
.btnMenu:hover {
  background-color: #e00a1c;
  transform: translateY(-2px);
  color: white;
}
@media (min-width: 768px) {
  .btnMenu {
    padding: 16px 44px;
    min-width: 150px;
  }
}
</style>